/* istanbul ignore file */
import * as React from 'react';
import { compose } from 'react-recompose';
import get from 'lodash/get';
import { withRouter } from 'react-router';
import Script from 'react-load-script';
import PropTypes from 'prop-types';
import initInlineManual, { getInlineManualUrl, updateInlineManual } from './helper';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';

export const InlineManualComponent = ({ heAccount, viewer, location = {} }) => {
  const [trackingData, setTrackingData] = React.useState();
  const id = get(heAccount, 'id');

  React.useEffect(() => {
    updateInlineManual();
  }, [location.pathname]);

  React.useEffect(() => {
    if (id) {
      const token = get(viewer, 'idToken') || {};
      const activeSubscriptions = get(heAccount, 'activeSubscriptions', []);
      const data = {
        uid: token['cognito:username'],
        roles: [token['custom:role']],
        plan: activeSubscriptions.join(','),
      };
      setTrackingData(true);
      window.inlineManualTracking = { ...data };
    }
  }, [id]);

  return trackingData ? <Script id="inline-manual" url={getInlineManualUrl()} onLoad={initInlineManual} /> : null;
};

InlineManualComponent.propTypes = {
  viewer: PropTypes.object,
  heAccount: PropTypes.object,
  location: PropTypes.object,
};

const InlineManualWithHEAccount = compose(
  withHEAccountSubscriptions,
  withRouter,
)(InlineManualComponent);

export default InlineManualWithHEAccount;
